<template>
  <UIContainer>
    <UIAlert v-if="paymentCancelled" variant="danger">
      We were unable to process your payment request.
    </UIAlert>
    <UIAlert v-else-if="paymentSuccess" variant="success">
      Your payment has been processed successfully. Thank you for your business.
    </UIAlert>

    <FormWizard v-else submit-label="Pay via Stripe" @submit="onSubmit">
      <UIAlert v-if="formError" variant="danger">
        {{ formError }}
      </UIAlert>

      <HiddenField name="form-type" :modelValue="formType" />
      <HiddenField
        :name="`${formType}-success_redirect`"
        :modelValue="successRedirect"
      />
      <HiddenField
        :name="`${formType}-cancel_redirect`"
        :modelValue="cancelRedirect"
      />
      <slot name="fields"></slot>

      <!-- Payment Details Stage -->
      <FormStep>
        <h3 class="text-primary py-3">Payment Details</h3>
        <slot name="payment-fields"></slot>
      </FormStep>

      <!-- Customer Details Stage -->
      <FormStep>
        <h3 class="text-primary py-3">Your Details</h3>
        <slot name="customer-fields"></slot>
      </FormStep>
    </FormWizard>
  </UIContainer>
</template>

<script lang="ts" setup>
import UIAlert from "@/components/UI/UIAlert.vue";
import UIContainer from "@/components/UI/UIContainer.vue";
import HiddenField from "@/components/fields/HiddenField.vue";
import FormStep from "@/components/forms/FormStep.vue";
import FormWizard from "@/components/forms/FormWizard.vue";
import { sendFormData } from "@/lib/submitForm";
import { loadStripe } from "@stripe/stripe-js";
import { GenericObject } from "vee-validate";
import { ref } from "vue";

const formType = "generic-payment-form";
const successRedirect = location.href.split("?")[0] + "?success=true";
const cancelRedirect = location.href.split("?")[0] + "?success=false";
const paymentSuccess = /success=true$/.test(location.href);
const paymentCancelled = /success=false$/.test(location.href);
const formError = ref<string | null>(null);

/**
 * Handle valid form submission.
 */
async function onSubmit(values: GenericObject) {
  try {
    const data = await sendFormData<{ session_id: string; stripe_key: string }>(
      "/forms/",
      values
    );

    const stripe = await loadStripe(data.stripe_key);

    if (!stripe) {
      throw `Couldn't load stripe module.`;
    }

    console.log("Payment success");
    // stripe.redirectToCheckout({ sessionId: data.session_id });
  } catch (error) {
    console.error("Error while submitting the form.", error);
    formError.value =
      "An error occurred while processing your data. Please try again later.";
    return;
  }
}
</script>
